/** Ключи хранилища */
export const SETTINGS_STORAGE_KEY = "boo-bloom:settings";
export const ONBOARDING_STORAGE_KEY = "boo-bloom:onboarding-shown";

/** Настройки пользователя */
export interface SettingsState {
  sound: boolean;
  haptics: boolean;
}

/** Дефолтные значения */
export const DEFAULT_SETTINGS: SettingsState = {
  sound: true,
  haptics: true,
};
